import styled, { keyframes } from "styled-components";
import { Box } from "@vinomofo/components";

const shimmer = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

const AnimatedLoader = styled(Box)`
  animation: ${shimmer} 2s infinite linear;
  background: linear-gradient(to right, #f6f7f8 4%, #edeef1 25%, #f6f7f8 36%);
  background-size: 1000px 100%;
`;

interface InputMockProps {
  height?: number;
  width?: string | number;
  mb?: number;
}

export const InputMock = ({
  height = 30,
  width = "100%",
  mb,
}: InputMockProps) => {
  return (
    <AnimatedLoader height={height} width={width} mb={mb} borderRadius="4px" />
  );
};
